/**
 * The one ads platform Core currently manages end-to-end.
 *
 * Meta and Bing are named in the surface (the platform toggle, a few labels)
 * but no code path writes to them from Core; every read/write we ship goes
 * to Google Ads. This constant is the single source of truth for that fact,
 * so the URL param, the toggle default, and any future guards all agree.
 *
 * Previously duplicated as a local `const` in GoogleAdsOpsPage and
 * AdsViewControls, which meant the URL param and the toggle default were
 * two independent literals that happened to match. Add Meta or Bing to the
 * union here when a real end-to-end write path lands.
 */
export const ACTIVE_ADS_PLATFORM = 'google-ads' as const;

export type ActiveAdsPlatform = typeof ACTIVE_ADS_PLATFORM;
